import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret, faTrash, faCopy, faPenToSquare, faPlus, faClone, faClock, faFileExport, faChevronRight, faChevronLeft, faUsers, faUser, faUserPlus, faEye, faEyeSlash, faGears, faUserCheck, faSquarePollHorizontal, faNetworkWired, faInfo, faCircleQuestion, faFilePen, faCircleCheck, faShuffle, faPaperPlane, faChevronDown, faArrowLeft, faGripLines, faAlignLeft, faSquareCheck, faCircleDot, faSquareCaretDown, faEllipsis, faCalendarDay, faCalendarDays, faFont, faLayerGroup, faCircleInfo, faPersonCircleCheck, faRecycle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import * as Sentry from '@sentry/vue';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import router from './router';
import translations from '@/translations';

library.add(
	faUserSecret,
	faTrash,
	faPenToSquare,
	faPlus,
	faClone,
	faFileExport,
	faChevronRight,
	faChevronLeft,
	faUsers,
	faUser,
	faUserPlus,
	faPlus,
	faEye,
	faEyeSlash,
	faGears,
	faCopy,
	faUserCheck,
	faSquarePollHorizontal,
	faNetworkWired,
	faInfo,
	faFilePen,
	faCircleQuestion,
	faSquarePollHorizontal,
	faCircleCheck,
	faShuffle,
	faPaperPlane,
	faChevronDown,
	faArrowLeft,
	faCircleInfo,
	faPersonCircleCheck,
	faRecycle,
	faClock,

	//SELECT ICON
	faGripLines,
	faAlignLeft,
	faSquareCheck,
	faCircleDot,
	faSquareCaretDown,
	faEllipsis,
	faCalendarDay,
	faCalendarDays,
	faClock,
	faFont,
	faLayerGroup,

);

const app = createApp(App);
app.use(createPinia());

const i18n = createI18n({
	locale: 'hu',
	legacy: false,
	globalInjection: true,
	messages: translations,
	warnHtmlMessage: false,
});

app
	.use(router)
	.use(i18n)
	.component('font-awesome-icon', FontAwesomeIcon);

////////////
// Sentry //
////////////
if (import.meta.env.VITE_ENV !== 'development') {
	Sentry.init({
		app,
		dsn: import.meta.env.VITE_SENTRY_DSN as string,
		environment: import.meta.env.VITE_ENV as string,
		ignoreErrors: [
			'TypeError: Failed to fetch',
			'TypeError: cancelled',
			'TypeError: visszavonva',
			'Non-Error promise rejection captured with keys:',
			'Non-Error promise rejection captured with value:',
			'Can\'t find variable: IntersectionObserver',
			'ResizeObserver loop limit exceeded',
		],
		tracesSampleRate: 0,
		autoSessionTracking: false,
	});
}

app.mount('#app');
